import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/program_validation`;

export const ACTION_TYPES = {
  FETCH_PROGRAMVALIDATION_LIST: 'PROGRAM/FETCH_PROGRAMVALIDATION_LIST',
  FETCH_PROGRAMVALIDATION: 'PROGRAM/FETCH_PROGRAMVALIDATION',
  CREATE_PROGRAMVALIDATION: 'PROGRAM/CREATE_PROGRAMVALIDATION',
  UPDATE_PROGRAMVALIDATION: 'PROGRAM/UPDATE_PROGRAMVALIDATION',
  DELETE_PROGRAMVALIDATION: 'PROGRAM/DELETE_PROGRAMVALIDATION',
  RESET: 'PROGRAM/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const programValidationReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PROGRAMVALIDATION_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PROGRAMVALIDATION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PROGRAMVALIDATION):
    case REQUEST(ACTION_TYPES.UPDATE_PROGRAMVALIDATION):
    case REQUEST(ACTION_TYPES.DELETE_PROGRAMVALIDATION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PROGRAMVALIDATION_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PROGRAMVALIDATION):
    case FAILURE(ACTION_TYPES.CREATE_PROGRAMVALIDATION):
    case FAILURE(ACTION_TYPES.UPDATE_PROGRAMVALIDATION):
    case FAILURE(ACTION_TYPES.DELETE_PROGRAMVALIDATION):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAMVALIDATION_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAMVALIDATION):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PROGRAMVALIDATION):
    case SUCCESS(ACTION_TYPES.UPDATE_PROGRAMVALIDATION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PROGRAMVALIDATION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default programValidationReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PROGRAMVALIDATION_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntityByProgramRevision = (id, revisionId) => ({
  type: ACTION_TYPES.FETCH_PROGRAMVALIDATION,
  payload: axios.get(`${apiUrl}/program/${id}/revision/${revisionId}`),
});

export const assignEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PROGRAMVALIDATION,
    payload: axios.post(`${apiUrl}/assign`, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const gradeEntity = (entity, page, size, sort) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PROGRAMVALIDATION,
    payload: axios.post(`${apiUrl}/grade`, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  dispatch(getEntities(page, size, sort));
  return result;
};

export const validateEntity = (entity, page, size, sort) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PROGRAMVALIDATION,
    payload: axios.post(`${apiUrl}/validate`, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  dispatch(getEntities(page, size, sort));
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
